export default __webpack_public_path__ + "static/fj-b0c145e160c4c02c809fd33b30885f5e.svg";